<h5 *ngIf="!showSend" mat-dialog-title i18n>Select Options</h5>
<h5 *ngIf="showSend" mat-dialog-title i18n>Email Material List to Branch</h5>

<div mat-dialog-content>
  <div *ngIf="!showSend">
    <p i18n>Select options for printing.</p>
    <form #printOptionsForm="ngForm" (ngSubmit)="printReport()">
      <div class="form-group">
        <select name="locale" class="form-control select-bidit" [(ngModel)]="locale">
          <option value="en">English</option>
          <option value="es">Español</option>
        </select>
      </div>
      <div>
        <mat-checkbox id="showJobAddress" name="showJobAddress" class="col-form-label" [(ngModel)]="showJobAddress" i18n>Include Job Address</mat-checkbox>
      </div>
      <div class="form-group float-right">
        <button type="button" (click)="sendEmail(this.showJobAddress)" mat-button class="btn btn-bidit-action mr-1" i18n>Send</button>
        <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Print</button>

        <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </form>
  </div>
  <div *ngIf="showSend">
    <p i18n>To add a message to the body of an email, fill in the message field or click send to just send the materials list.</p>
    <form #emILOptionsForm="ngForm" (ngSubmit)="emailMaterialsList()">

      <h5 *ngIf="data.assignedToEmail=== null && data.dealer_IDIBranchEmail === null" i18n>No contact found for customer</h5>
      <div *ngIf="data.dealer_IDIBranchEmail !== null" class="form-group row">
        <label for="emailMessage" class="col-sm-6 col-form-label">
          ({{data.dealer_IDIBranchEmail}})
        </label>

        <div class="col-sm-3">
          <input type="checkbox" name="branchEmail_selected"
                 id="branchEmail_selected"
                 class="bidit-switch-rg" [(ngModel)]="branchEmail_selected" />
          <span i18n>Send</span>
        </div>
      </div>
      <div *ngIf="data.assignedToEmail !== null" class="form-group row">
        <label for="cc_selected" class="col-sm-6 col-form-label">
          CC ({{data.assignedToEmail}})
        </label>

        <div class="col-sm-3">
          <input type="checkbox" name="cc_selected"
                 id="cc_selected"
                 class="bidit-switch-rg" [(ngModel)]="cc_selected" />
          <span i18n>Send</span>
        </div>
      </div>
      <div class="form-group row">
        <label for="emailMessage" class="col-sm-4 col-form-label" i18n>Message</label>
        <div class="col-sm-8">
          <textarea class="form-control" name="emailMessage" id="emailMessage"
                    rows="3"
                    [(ngModel)]="emailMessage" #quoteEmail_Message="ngModel">
      </textarea>
        </div>
      </div>
      <div class="form-group float-right" *ngIf="!isRequesting">
        <button *ngIf="data.assignedToEmail !== null || data.dealer_IDIBranchEmail !== null" mat-button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
        <button mat-button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </form>
  </div>
</div>
